import { AppState } from 'domains/contracts/appState'
import { AlertConfig } from 'domains/commons/states'

export default (state: AppState): AlertConfig => state.common.alert
